import { forwardRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Wrapper,
  StyledInput,
  StyledInputAdornment,
  ResetButton,
} from "./TextInput.styled";

type TextInputProps = {
  defaultValue?: any;
  value?: any;
  onClick?: (params?: any) => void;
  onChange?: (params?: any) => void;
  onEnter?: (params?: any) => void;
  onReset?: (params?: any) => void;
  placeholder?: string;
  endAdornment?: string;
  disabled?: boolean;
  autoComplete?: string;
  style?: any;
  type?: string;
};

export const TextInput = forwardRef(
  (
    {
      defaultValue,
      value,
      onClick,
      onChange,
      onEnter,
      onReset,
      placeholder,
      endAdornment,
      disabled,
      style,
      autoComplete,
      type,
    }: TextInputProps,
    ref
  ) => {
    const handleChange = (e: any) => {
      onChange && onChange(e.target.value);
    };

    return (
      <Wrapper style={style}>
        <StyledInput
          inputRef={ref}
          variant="outlined"
          defaultValue={defaultValue}
          value={value}
          onChange={handleChange}
          onKeyDown={(e) => e.keyCode == 13 && onEnter && onEnter()}
          placeholder={placeholder}
          disabled={disabled}
          autoComplete={autoComplete ?? "false"}
          InputProps={{
            endAdornment: endAdornment && (
              <StyledInputAdornment position="end">
                {endAdornment}
              </StyledInputAdornment>
            ),
            style: { paddingRight: "8px" },
          }}
          onClick={onClick}
          type={type}
        />
        {onReset && (
          <ResetButton aria-label="reset" onClick={onReset}>
            <CloseIcon />
          </ResetButton>
        )}
      </Wrapper>
    );
  }
);

export default TextInput;
